import React from 'react';
import propTypes from 'prop-types';
;;
import { Button, Columns, Column, ModalCardBody, ModalCardHeader, ModalCardTitle, ModalCard, ModalBackground, Modal, Control, Field as BulmaField } from 'src/ui/mui-ui-kit';;
import { usePoseWithBulma } from 'src/ui/hooks';
import {
  FadeInDiv,
  AnimatedCard,
  UiInputAdapter,
  InnerLoader,
  UiMultiFileUploaderAdapter,
  UiDatePickerAdapter,
} from 'src/ui';
import { Form, Field, FormSpy } from 'react-final-form';
import { composeValidators, required } from 'src/ui/validations';

export function AddProductModal({
  isActive,
  onCancel,
  onSubmit,
  initialValues,
}) {
  const [currentPose, isModalVisible, onPoseComplete] = usePoseWithBulma(
    isActive
  );
  const action = initialValues && initialValues.id ? 'Edit' : 'Add';

  return (
    <Form
      onSubmit={onSubmit}
      initialValues={initialValues}
      render={({ form, hasValidationErrors, submitting, handleSubmit }) => (
        <form onSubmit={handleSubmit} noValidate>
          <FormSpy
            subscription={{ submitting: true, submitSucceeded: true }}
            onChange={({ submitting, submitSucceeded }) =>
              !submitting && submitSucceeded && form.reset()
            }
          />
          <Modal isActive={isModalVisible} className="add-account-modal">
            <ModalBackground
              tag={FadeInDiv}
              pose={currentPose}
              onPoseComplete={onPoseComplete}
            />
            <ModalCard tag={AnimatedCard} pose={currentPose}>
              <InnerLoader visible={submitting} />
              <ModalCardHeader>
                <ModalCardTitle
                  tag="h5"
                  className="has-text-weight-semibold is-vcentered has-text-primary"
                >
                  {action} Product
                </ModalCardTitle>
              </ModalCardHeader>
              <ModalCardBody>
                <Columns isMultiline>
                  <Column isSize="full">
                    <Field
                      component={UiInputAdapter}
                      id="name"
                      name="name"
                      label="Product Name"
                      required
                      validate={composeValidators('Product Name', required)}
                    />
                  </Column>

                  <Column isSize="full">
                    <Field
                      component={UiInputAdapter}
                      id="batchNumber"
                      name="batchNumber"
                      label="Batch #"
                      required
                      validate={composeValidators('Batch #', required)}
                    />
                  </Column>

                  <Column isSize="full">
                    <Field
                      component={UiDatePickerAdapter}
                      id="expirationDate"
                      name="expirationDate"
                      label="Expiration Date"
                      required
                      withPortal
                      menuPortalTarget={document.body}
                    />
                  </Column>

                  <Column isSize="full">
                    <Field
                      component={UiMultiFileUploaderAdapter}
                      id="coas"
                      name="coas"
                      label="Upload COA Files"
                      type="file"
                    />
                  </Column>
                </Columns>

                <BulmaField isGrouped="centered">
                  <Control>
                    <Button hasTextColor="info" onClick={() => onCancel(form)}>
                      Cancel
                    </Button>
                  </Control>
                  <Control>
                    <Button
                      isColor="gradient-bright"
                      type="submit"
                      disabled={submitting || hasValidationErrors}
                    >
                      {action}
                    </Button>
                  </Control>
                </BulmaField>
              </ModalCardBody>
            </ModalCard>
          </Modal>
        </form>
      )}
    />
  );
}

AddProductModal.defaultProps = {
  initialValues: {},
};

AddProductModal.propTypes = {
  isActive: propTypes.bool.isRequired,
  onCancel: propTypes.func.isRequired,
  onSubmit: propTypes.func.isRequired,
  initialValues: propTypes.object,
};
